import React, { useEffect, useRef } from 'react';

import MainHome from './NewHome/MainHome';

import { Box } from '@mui/material';

import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import DemoBookingPrompt from '../../components/DemoBooking/DemoBookingPrompt';

const HomePage = () => {
  const ref = useRef(null);
  const Location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => {
      if (window.scrollY === 0) {
        window.scrollTo(0, 0);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(() => {
    if (Location?.state === 'ABClick') {
      return ref.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <Box sx={{ width: '100%', maxWidth: '100%' }}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Barter Companies in India &amp; B2B Barter Exchange Platform | BXI</title>
        <meta property="og:title" content="Barter Companies in India & B2B Barter Exchange Platform | BXI" />
        <link rel="canonical" href="https://bxiworld.com/" />
        <meta
          name="og:description"
          content="BXI (Barter Exchange of India) is India's largest B2B barter marketplace, helping businesses trade goods and services through a trusted barter system without cash outflow."
        />
        <meta
          name="description"
          content="BXI (Barter Exchange of India) is India's largest B2B barter marketplace, helping businesses trade goods and services through a trusted barter system without cash outflow."
        />
        <meta
          name="keywords"
          content=" Barter exchange, barter system, bxi, barter exchange, b2b, marketplace, barter, b2b marketplace"
        />
      </Helmet>

      <>
        <Box
          sx={{
            pt: { xs: '56px', sm: '64px' },
          }}
        >
          <DemoBookingPrompt />
          <MainHome />
        </Box>
      </>

    </Box>
  );
};

export default HomePage;

